<template>
  <router-link tag="div" class="tearch-wrap" :to="'/daka/'+data.id">
    <div class="avatar">
      <div>
        <img v-lazy="data.icon" alt="">
      </div>
    </div>
    <div>
      <div class="name" v-html="data.name"></div>
      <div class="spec" v-html="data.honor"></div>
      <div class="label">
        <span v-if="data.course_total">{{data.course_total}}节课程</span>
        <span v-if="data.level_desc">{{data.level_desc}}</span>
      </div>
      <div class="follow">
        <i class="iconfont icon-huo"></i>{{data.browses}}
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>

<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .tearch-wrap{
    display table
    width 100%
    min-height size(150)
    margin-bottom size(30)
    >div{
      display table-cell
      vertical-align top
      &:nth-child(2){
        padding-left size(20)
        position relative
      }
    }
    .avatar{
      width size(150)
      height size(150)
      >div{
        width size(150)
        height size(150)
        // border-radius 50%
        // background #c2c2c2
        overflow hidden
        img{
          display block
          width 100%
          height 100%
        }
      }
    }
    .name{
      font-size size(30)
      color #222
      line-height 1.4
    }
    .spec{
      font-size size(24)
      color #8a8a8a
      margin size(16) 0 size(20)
    }
    .label{
      span{
        display inline-block
        background $color-light
        color #fff
        font-size 10px
        padding size(0) size(8)
        line-height 17px
        height 16px
        border-radius 2px
        margin-right size(8)
      }
    }
    .follow{
      font-size size(18)
      color #8a8a8a
      position absolute
      right 0
      top size(12)
      .iconfont{
        color #ff001f
        font-size 10px
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/card/card-teacher.vue